module.exports = __webpack_public_path__ + "static/media/LCD-kortit-FI.0a2442ef.png";